import { uploadProductsExcel } from '@gozoki/api';
import { useMutation } from '@tanstack/react-query';
import { ROUTES } from '../../utils/constants/routes.constants';

import { XlsxImportError } from '@gozoki/api-types';
import { AxiosError } from 'axios';
import { XslxImport } from '../../components/XslxImport';

const ImportProductPage = () => {
    const { mutateAsync: mutateUploadProduct } = useMutation({
        mutationFn: uploadProductsExcel,
    });

    return (
        <XslxImport
            onSubmit={async (file) => {
                try {
                    const data = await mutateUploadProduct(file);
                    return { data };
                } catch (error) {
                    if (error instanceof AxiosError) {
                        return { error: error.response?.data as XlsxImportError };
                    }
                    return { error: { message: 'Une erreur inconnue est survenue', errors: [] } };
                }
            }}
            resourceName="produit"
            goBackRoute={ROUTES.PRODUCTS}
        />
    );
};

export default ImportProductPage;
